<template>
  <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base userItem">
    <vx-card class="text-center" style="height:180px;" v-if="examInfo" scrollHeight>
      <div style="position:absolute; width:45px; height:20px; top:5px; left:5px; padding:1px 0; font-size:12px; font-weight:bold; border-radius:40px; background:#ffe998" v-if="this.examInfo.info == 'sat'">
        <p>수능</p>
      </div>
      <div style="position:absolute; width:45px; height:20px; top:5px; left:5px; padding:1px 0; font-size:12px; font-weight:bold; border-radius:40px; background:#ffe998"
            v-if="this.examInfo.info == 'high' && this.examInfo.grade == 2">
        <p>고2</p>
      </div>
      <div style="position:absolute; width:45px; height:20px; top:5px; left:5px; padding:1px 0; font-size:12px; font-weight:bold; border-radius:40px; background:#ffe998"
            v-if="this.examInfo.info == 'high' && this.examInfo.grade == 1">
        <p>고1</p>
      </div>
      <div class="text-center">
          <div class="state" style="">
            <button type="button" name="button" :class="{active : item.isActive}" v-for="(item, index) in button_state" :key="index" @click="changeState(item)">{{ item.state }}</button>
          </div>
        <vs-button class="w-full" color="primary" type="flat" style="font-size: 15px; width:15px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;" @click="showExam()"><strong>{{examInfo.test_name}}</strong></vs-button>
      </div>
      <div>
        <vs-divider style="margin-top:2px;"/>
        <div class="flex justify-center flex-wrap" style="margin-top:10px;">
          <!-- <p style="margin-right:5px;"> {{subjectInfo.subject}} </p> &nbsp; -->
          <vs-button color="primary" style="margin-right:3px" type="border" icon-pack="feather" size="small" icon="icon-list" @click="showSubject()"></vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>


<script>
export default {
  props: ['examInfo'],
  data() {
    return {
      serviceVal: false,
      data_local:'',
      button_state: [
        {id: 0, state: '작성중', isActive: false},
        {id: 1, state: '완료', isActive: false}
      ],
    }
  },
  created () {
    if(!this.examInfo){
      return
    }
    this.button_state[this.examInfo.state].isActive = true
  },
  computed: {
  },
  methods: {
    changeState(val) {
      this.$emit('state', {
        state: val.id,
        exam_id: this.examInfo.id
      })
    },
    showExam() {
      this.$store.commit('etest/ACTIVE_EXAML', this.examInfo)
      this.$router.push('/apps/etest/editer/0')
    },
    showSubject(){
      this.$store.commit('etest/ACTIVE_EXAML', this.examInfo)
      this.$router.push('/apps/etest/editer/1')
    }
  }
}
</script>

<style>
.text {
    font-size: 14px;
    max-width: 400px;
    line-height: 1.5;
}
.userItem .state button{
  background-color: #fff;
  outline: none;
  color: #333;
  border: 1px solid #ddd;
  padding: 7px 0;
  font-weight: bold;
  transition: 0.3s;
  cursor: pointer;
}
.userItem .state button:hover{
  background-color: #F9EFC9;
}
.userItem .state button:nth-child(1){
  width:60px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.userItem .state button:nth-child(2){
  width:60px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.userItem .state button.active{
  background-color: #ffe998;
}
</style>
